var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"jsm-modal-wrapper",attrs:{"id":"jsm-modal-wrapper"},on:{"click":_vm.close}},[_vm._t("default",null,{"text":_vm.message})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }